import styled from 'styled-components';
import { ifProp } from 'styled-tools';
import { convertColorToThemeHexCode } from 'Styles/colors.util';
import { fontBody, fontTitle } from 'Styles/fonts';
import LinkText from '../../components/LinkText/LinkText';

const LinkGroupPaddingValues = {
  sm: '8px',
  md: '28px',
  lg: '32px'
};

export const Link = styled.a`
  display: block;
  position: relative;
  text-decoration: none;
  color: ${({ color, withHighlight }) =>
    color ||
    (withHighlight
      ? convertColorToThemeHexCode('red')
      : convertColorToThemeHexCode('black'))};
  ${({ variant }) =>
    variant === 'mini' ? `${fontBody(14)};` : `${fontBody(16)};`}

  &:hover {
    text-decoration: underline;
  }

  ${({ $withArrow, variant }) =>
    $withArrow &&
    `
      &::after {
        font-family: var(--icon-font);
        content: '\\F008';
        position: absolute;
        ${
          variant === 'mini'
            ? `
            font-size: 14px;
            margin: 0 4px;
          `
            : `
            font-size: 24px;
            margin: 0 10px;
          `
        }
    `}
`;

export const HeaderLink = styled(LinkText)`
  padding-top: ${ifProp('withTopMargin', '16px', '0')};
  padding-bottom: 12px;
  ${({ accentFont }) =>
    accentFont && 'font-family: var(--accent-font); font-weight: 400;'}
`;

export const SubtextLink = styled(LinkText)`
  padding-bottom: 12px;
  display: block;
`;

export const Subtitle = styled.h2`
  color: var(--foreground);
  padding-bottom: 12px;
  padding-left: ${ifProp('withLeftMargin', '24px', '0')};
  ${({ variant }) =>
    variant === 'mini' ? `${fontTitle(12)};` : `${fontTitle(16)};`}
  ${({ accentFont }) =>
    accentFont && 'font-family: var(--accent-font); font-weight: 400;'}
`;

export const LinkGroup = styled.div`
  ${({ withHorizontalPadding }) =>
    withHorizontalPadding && 'padding-left: 24px; padding-right:24px'};
  ${({ paddingSize }) => `
    padding-bottom: ${
      LinkGroupPaddingValues[paddingSize] || LinkGroupPaddingValues.sm
    };
  `}
  display: flex;
  flex-direction: column;
  ${({ variant }) => (variant === 'mini' ? 'row-gap: 12px' : 'row-gap: 16px;')};
`;
